export default __webpack_public_path__ + "static/media/Logo Bez Tekstu.e2189e9f.svg";